import styles from '@components/components/EnergieSparCheck/EnergieSparCheck.module.scss';
import Container from '@components/components/Container/Container';
import {
  questions,
  getResults,
} from '@components/components/EnergieSparCheck/EnergieSparCheck.config.js';
import FinalStep from '@components/components/EnergieSparCheck/FinalStep';
import { useSessionStorage, useTracking } from '@components/hooks';
import { Button as BaseButton } from '@ariakit/react';
import { ChoiceCard, Heading, ProgressBar } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

const QuestionsComponent = ({
  title,
  name: optionLabel,
  options,
  setStep,
  step,
  stepLength,
  setAnswers,
  answers,
  track,
}) => {
  const handleClick = (text, param, label) => {
    setStep(prev => prev + 1);
    const updatedAnswers = [...answers, { text, param, label }];
    setAnswers(updatedAnswers);
    // Energiesparcheck STEP useTracking - last step tracked separate
    if (step < stepLength) {
      track({
        event: 'EnergiesparCheck',
        answers: updatedAnswers?.map(answer => answer?.text),
        steps: step,
      });
    }
  };
  const handleProgressBarClick = id => {
    setStep(id);
    const adjustetAnswers = answers;
    adjustetAnswers.length = id - 1;
    setAnswers(adjustetAnswers);
  };

  return (
    <div aria-label="Energiesparcheck" className={styles.container}>
      <Container className={classNames(styles.questions)} size="lg">
        <ProgressBar
          currentStep={step}
          noLabel
          onClick={handleProgressBarClick}
          steps={questions}
        />
        <Heading as="h3" className={styles.title} size="h3" tabIndex={0}>
          {title}
        </Heading>
        <div className={styles.optionsWrapper}>
          {options?.map(({ text, param }) => (
            <ChoiceCard
              as={BaseButton}
              key={text}
              onClick={() => handleClick(text, param, optionLabel)}
              title={text}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

const EnergySparCheck = ({ mainPosts }) => {
  const [step, setStep] = useState(1);
  const [answers, setAnswers] = useState([]);
  const [results, setResults] = useState(null);
  const track = useTracking();

  const [storage, setStorage] = useSessionStorage('show-conditional', 'hide');

  const questionsToRender = questions?.map((item, index) => ({
    ...item,
    order: index + 1,
  }));

  const setStorageInitial = () => {
    setStorage('hide');
  };

  useEffect(() => {
    window.addEventListener('beforeunload', setStorageInitial);

    return () => {
      window.removeEventListener('beforeunload', setStorageInitial);
    };
  }, []);

  useEffect(() => {
    if (step === questionsToRender.length + 1) {
      const { results: finalResults } = getResults(answers);
      setResults(finalResults);
      setStorage('show');

      // Energiesparcheck send
      track({
        event: 'EnergiesparCheck',
        answers: answers?.map(answer => answer.text),
        steps: 'send',
      });

      // Energiesparcheck Ergebnis
      track({
        event: 'EnergiesparCheck',
        answers: finalResults
          ?.sort(({ value: a }, { value: b }) => b - a)
          .map((result, index) => `${index + 1} ${result?.name}`),
        steps: 'result',
      });
    }
  }, [step]);

  const renderSteps = () => {
    const [CurrentStepComponent] = questionsToRender.filter(
      ({ order }) => order === step,
    );

    return (
      <>
        {CurrentStepComponent && (
          <QuestionsComponent
            answers={answers}
            setAnswers={setAnswers}
            setStep={setStep}
            step={step}
            stepLength={questionsToRender.length}
            track={track}
            {...questions[step - 1]}
          />
        )}
        {results && <FinalStep mainPosts={mainPosts} results={results} />}
      </>
    );
  };

  return renderSteps(step);
};

export default EnergySparCheck;
